"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateWorkOrderRequest = exports.CreateJobVariationResponseSchema = exports.UpdateJobRequestSchema = exports.JobDetailsParamsSchema = exports.JobDetailsResponseSchema = exports.ListJobsResponse = exports.JobsStatusCountSchema = exports.JobSummarySchema = exports.GetJobsQuery = exports.CreateInstantJobRequest = exports.JobQuoteResponse = exports.JobResponse = exports.CreateJobRequest = void 0;
const zod_1 = require("zod");
const quotes_types_1 = require("./quotes.types");
const sharedStatus_types_1 = require("./sharedStatus.types");
const JobAppointmentDetailsSchema = zod_1.z.object({
    assignment: zod_1.z.object({
        id: zod_1.z.string(),
        firstName: zod_1.z.string(),
        lastName: zod_1.z.string(),
    }),
    startDateTime: zod_1.z.string().datetime(),
    endDateTime: zod_1.z.string().datetime(),
    allDay: zod_1.z.boolean(),
});
const JobAppointmentCreateSchema = zod_1.z.object({
    assignedUserId: zod_1.z.string(),
    startDateTime: zod_1.z.string().datetime(),
    endDateTime: zod_1.z.string().datetime(),
    allDay: zod_1.z.boolean(),
});
exports.CreateJobRequest = zod_1.z.object({
    quoteId: zod_1.z.string(),
    appointment: JobAppointmentCreateSchema.optional(),
    status: zod_1.z.nativeEnum(sharedStatus_types_1.JobStatus).optional(),
});
exports.JobResponse = zod_1.z.object({
    data: zod_1.z.object({
        id: zod_1.z.string(),
    }),
});
exports.JobQuoteResponse = zod_1.z.object({
    data: zod_1.z.object({
        id: zod_1.z.string(),
        quoteId: zod_1.z.string(),
    }),
});
exports.CreateInstantJobRequest = zod_1.z.object({
    quote: quotes_types_1.CreateQuoteRequestSchema,
    appointment: JobAppointmentCreateSchema,
    notes: zod_1.z.string().optional(),
});
exports.GetJobsQuery = zod_1.z.object({
    search: zod_1.z.string().optional(),
});
exports.JobSummarySchema = zod_1.z.object({
    id: zod_1.z.string(),
    status: zod_1.z.nativeEnum(sharedStatus_types_1.JobStatus),
    appointment: JobAppointmentDetailsSchema.optional(),
    quote: zod_1.z.object({
        id: zod_1.z.string(),
        name: zod_1.z.string(),
        number: zod_1.z.number(),
        customerName: zod_1.z.string(),
        address: zod_1.z.string(),
        materialsCount: zod_1.z.number(),
        attachmentsCount: zod_1.z.number(),
    }),
    variation: zod_1.z
        .object({
        id: zod_1.z.string(),
    })
        .optional(),
});
exports.JobsStatusCountSchema = zod_1.z.object({
    [sharedStatus_types_1.JobStatus.INSTANT]: zod_1.z.number(),
    [sharedStatus_types_1.JobStatus.IN_PROGRESS]: zod_1.z.number(),
    [sharedStatus_types_1.JobStatus.DONE]: zod_1.z.number(),
    [sharedStatus_types_1.JobStatus.SCHEDULED]: zod_1.z.number(),
    [sharedStatus_types_1.JobStatus.TO_SCHEDULE]: zod_1.z.number(),
});
exports.ListJobsResponse = zod_1.z.object({
    data: zod_1.z.array(exports.JobSummarySchema),
    meta: zod_1.z.object({
        statusCount: exports.JobsStatusCountSchema,
    }),
});
exports.JobDetailsResponseSchema = zod_1.z.object({
    data: exports.JobSummarySchema,
});
exports.JobDetailsParamsSchema = zod_1.z.object({
    id: zod_1.z.string(),
});
exports.UpdateJobRequestSchema = zod_1.z.object({
    appointment: JobAppointmentCreateSchema,
});
exports.CreateJobVariationResponseSchema = zod_1.z.object({
    data: zod_1.z.object({
        jobId: zod_1.z.string(),
        variationId: zod_1.z.string(),
    }),
});
exports.CreateWorkOrderRequest = zod_1.z.object({
    email: zod_1.z.string(),
    instructions: zod_1.z.string(),
});
